<template>
  <div class="page-content pb-0">
    <Titlebar
      incrustation="fa-bullhorn"
      :backPath="{ name: 'RemoteMonitoringList' }"
    >
      <h1>{{ $t("remoteMonitoring.titles.log") }}</h1>
    </Titlebar>
    <UiCard>
      <Btn
        class="secondary no-hover filters mb-3"
        @click.native.stop="toggleFilters"
      >
        <i class="fa fa-filter"></i>&nbsp;&nbsp;&nbsp;{{
          $t("global.filters")
        }}&nbsp;&nbsp;&nbsp;<i class="fa fa-caret-down"></i>
        <div
          slot="actions"
          class="button-actions up"
          :class="{ show: showFilters }"
          v-on-clickaway="closeFilters"
          @click.stop=""
        >
          <form style="width: 300px" class="p-4">
            <div class="form-row row">
              <label class="col-4">{{
                $t("remoteMonitoring.filters.type")
              }}</label>
              <select class="form-input col-8" v-model="filters.type">
                <option></option>
                <option value="1">
                  {{ $t("remoteMonitoring.filters.types.1") }}
                </option>
                <option value="2">
                  {{ $t("remoteMonitoring.filters.types.2") }}
                </option>
                <option value="3">
                  {{ $t("remoteMonitoring.filters.types.3") }}
                </option>
                <option value="4">
                  {{ $t("remoteMonitoring.filters.types.4") }}
                </option>
              </select>
            </div>
            <div class="form-row row">
              <label class="col-4">{{
                $t("remoteMonitoring.filters.state")
              }}</label>
              <select class="form-input col-8" v-model="filters.state">
                <option></option>
                <option value="1">
                  {{ $t("remoteMonitoring.filters.states.1") }}
                </option>
                <option value="0">
                  {{ $t("remoteMonitoring.filters.states.0") }}
                </option>
              </select>
            </div>
            <div class="form-row row">
              <label class="col-4">{{
                $t("remoteMonitoring.filters.dati")
              }}</label>
              <select class="form-input col-8" v-model="filters.device">
                <option></option>
                <option
                  v-for="device in devices"
                  :key="device.id"
                  :value="device.id"
                >
                  {{ device.name }}
                </option>
              </select>
            </div>
            <div class="form-row row">
              <label class="col-4">{{
                $t("remoteMonitoring.filters.user")
              }}</label>
              <input
                type="text"
                class="form-input col-8"
                v-model="filterUser"
                @keyup="debounceFilter"
              />
            </div>
            <div class="form-row row" style="margin-bottom: 0">
              <label class="col-4">{{
                $t("remoteMonitoring.filters.date")
              }}</label>
              <input
                type="text"
                v-inputmask="'99/99/9999'"
                class="form-input col-8"
                v-model.lazy="filters.date"
              />
            </div>
          </form>
        </div>
      </Btn>
      <div class="p-3" v-if="this.isLoading" >
        <UiSpinner/>
      </div>
      <div class="table-container" v-if="!this.isLoading">
        <table class="table" v-if="!!tableData.length">
          <tr v-for="row in tableData" class="w-100">
            <td class="p-1">
              <span
                class="icon-circle"
                :class="{
                  'state-ok': row.status == 1,
                  'state-ko': row.status == 0,
                  'state-pending': row.status == 2,
                }"
                ><i :class="getTypeIcon(row.type)"></i
              ></span>
            </td>
            <td style="width: calc(100% - 200px)">
              <span class="description">{{ row.payload }}</span>
            </td>
            <td>
              <span v-if="row.user != ''"
                >{{ $t("by") }} <strong>{{ row.user }}</strong></span
              >
            </td>
            <td>
              <span
                ><strong>{{ row.sentAt | only_date }}</strong> {{ $t("at") }}
                <strong>{{ row.sentAt | only_time }}</strong></span
              >
            </td>
          </tr>
        </table>
        <div v-else class="text-center">
          {{ $t('global.no_results') }}
        </div>
      </div>
      <div class="pagination-container">
        <Pagination
          ref="pagination"
          @change="handlePagination"
          :class="'reverse'"
        ></Pagination>
      </div>
    </UiCard>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/services/API.js";
import Utils from "@/services/utils.js";
import Btn from "@/components/ui/Button";
import UiCard from "@/components/ui/Card";
import Pagination from "@/components/ui/Pagination";
import Globals from "@/services/globals.js";
import moment from "moment";
import Titlebar from "@/components/ui/Titlebar";
import auth from "@/services/auth.js";
import UiSpinner from "@/components/ui/UiSpinner.vue";

import Icons from "@/services/iconMapping.js";

import { mixin as clickaway } from "vue-clickaway";

import _debounce from "lodash/debounce";

export default {
  name: "RemoteMonitoringLogs",
  components: {
    Btn,
    Pagination,
    Titlebar,
    UiSpinner,
    UiCard,
  },
  data() {
    return {
      config: {
        perpage: Globals.perPage,
        fields: [],
        page: 1,
        filter: {
          like: [],
          equals: [],
        },
        sort: ["-sentAt"],
      },
      filters: {
        type: null,
        state: null,
        device: null,
        user: "",
        date: "",
      },
      filterUser: "",
      tableData: [],
      showFilters: false,
      firstTimeFilters: true,
      devices: [],
      provider: {
        id: auth.providerId,
      },
      isLoading: true,
    };
  },
  methods: {
    handlePagination: function (page) {
      this.config.page = page;
      this.loadData();
    },

    loadData: function () {
      this.isLoading = true;
      if (this.provider != null) {
        axios
          .get(
            API.route(API.endpoints.remoteMonitoring.logs, {
              providerId: this.provider.id,
            }) + API.constructQueryParams(this.config)
          )
          .then((response) => {
            this.tableData = response.data.data;
            this.$refs.pagination.update(response.data.meta.pagination);
            this.isLoading = false;
            window.Vfc.$refs.loading.hide();
          })
          .catch((e) => {
            this.isLoading = false;
            window.Vfc.$refs.loading.hide();
          });
      }
    },
    loadDevices: function () {
      axios
        .get(
          API.endpoints.datis.index +
            API.constructQueryParams({ perpage: 9999999999999 })
        )
        .then((response) => {
          this.devices = response.data.data;
        });
    },
    getTypeIcon(type) {
      if (type != null) {
        return Icons.remoteMonitoringLogsTypes[type.toString()];
      }
      return "";
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters;
      if (this.showFilters) {
        this.firstTimeFilters = false;
      } else {
        this.firstTimeFilters = true;
      }
    },
    closeFilters: function () {
      if (this.showFilters && !this.firstTimeFilters) {
        this.showFilters = false;
        this.firstTimeFilters = true;
      } else {
        this.firstTimeFilters = false;
      }
    },
    debounceFilter: _debounce(function () {
      this.filters.user = this.filterUser;
    }, 500),
  },
  mixins: [clickaway],
  mounted: function () {
    this.loadDevices();
    this.loadData();
  },
  watch: {
    provider(newVal) {
      this.filters = {
        type: null,
        state: null,
        device: null,
        user: "",
        date: "",
      };
      this.filterUser = "";
    },
    filters: {
      deep: true,
      handler: function (newVal) {
        this.config.filter.like = [];
        this.config.filter.equals = [];
        if (this.filters.type != null && this.filters.type != "") {
          this.config.filter.equals.push("type:" + this.filters.type);
        }
        if (this.filters.state != null && this.filters.state != "") {
          this.config.filter.equals.push("status:" + this.filters.state);
        }
        if (this.filters.user != null && this.filters.user != "") {
          this.config.filter.like.push("user:" + this.filters.user);
        }
        if (this.filters.date != null && this.filters.date != "") {
          this.config.filter.like.push(
            "sentAt:" +
              moment(this.filters.date, Utils.t("datetime.date")).format(
                "YYYY-MM-DD"
              )
          );
        }
        if (this.filters.device != null && this.filters.device != "") {
          this.config.filter.equals.push("datiId:" + this.filters.device);
        }
        this.loadData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-circle {
  --icon-size: 2rem;

  color: var(--colors-white);
  background-color: var(--colors-gray-500);
  border-radius: 50%;
  display: inline-block;
  height: var(--icon-size);
  width: var(--icon-size);

  i {
    font-size: 1.3rem;
    line-height: var(--icon-size);
    text-align: center;
    width: 100%;
  }

  &.state-ok {
    background-color: var(--colors-success-500); //$messages-success-main-color;
  }

  &.state-ko {
    background-color: var(--colors-danger-500); //$messages-error-main-color;
  }

  &.state-pending {
    background-color: var(--colors-warning-500); //$messages-warning-main-color;
  }
}
</style>
